import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/styles";
import _, { isEqual } from "lodash";
import { Form, withFormik, useField } from "formik";
import { colors } from "../../theme/variables";
import { Button, Input } from "../../components";
import {
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Grid,
  Checkbox,
} from "@material-ui/core";
import * as Icons from "@material-ui/icons";
import FormikSwitch from "../../components/formik/FormikSwitch";
import FormikInput from "../../components/formik/FormikInput";
import FormikDropdown from "../../components/formik/FormikDropdown";
import { getCategories } from "../../data/services/API";
import * as Yup from "yup";
import { useWorkflowNames } from "../../data/workflow";
import { TIMEOUT_POLICY_OPTIONS } from "../../data/constants/rawData";
import { useHeaderParameterManager } from "../../components/InputParameterManager/useHeaderParameterManager";
import { KeyValue } from "../../components/forms/taskParams/KeyValue";
import FormikDropdownAutoComplete from "../../components/formik/FormikDropdownAutoComplete";

const useCustomStyles = makeStyles({
  inputField: {
    "& .MuiOutlinedInput-root": {
      height: "35px !important",
    },
    "& .MuiOutlinedInput-input": {
      padding: "6px 14px !important",
      height: "20px !important",
    },
  },
  dropdownField: {
    "& .MuiAutocomplete-input": {
      height: "23px !important",
      padding: "6px 14px !important",
      display: "flex !important",
      alignItems: "center !important",
    },
  },
});

const useStyles = makeStyles({
  name: {
    width: "50%",
  },
  description: {
    padding: 0,
    "& .MuiInputBase-root": {
      padding: "5px",
    },
  },
  submitButton: {
    float: "right",
  },
  toolbar: {
    backgroundColor: colors.gray14,
  },
  workflowName: {
    fontWeight: "bold",
  },
  main: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    overflow: "auto",
    backgroundColor: "#fff",
  },
  fields: {
    width: "100%",
    padding: 12,
    flex: 1,
    display: "flex",
    flexDirection: "column",
    overflowX: "hidden",
    overflowY: "auto",
    gap: 15,
  },
  formLabel: {
    fontSize: "13px",
    fontWeight: 600,
    marginBottom: "0.5rem",
    display: "block",
  },
  iconContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "30px",
    height: "20px",
    cursor: "pointer",
    color: colors.red07
  },
  icon: { cursor: "pointer" },
  switchContainer: { marginLeft: 0 },
  switchRoot: { marginRight: "1rem" },
  wfFlafDiv: { marginBottom: "0.5rem" },
  msgTxt: {
    fontSize: "12px",
    textAlign: "justify",
    marginTop: "0.5rem",
  },
  wolkenBtn: {
    padding: "4px 0",
    fontSize: "0.75rem",
    fontFamily: "Poppins, regular",
    lineHeight: "1.5",
  },
});



function secondsToDhms(timeSeconds) {
  var days = 0;
  var hours = 0;
  var minutes = 0;
  var seconds = 0;
  if (!Number.isNaN(timeSeconds)) {
    var secondVals = Number(timeSeconds);
    days = Math.floor(secondVals / (3600 * 24));
    hours = Math.floor((secondVals % (3600 * 24)) / 3600);
    minutes = Math.floor((secondVals % 3600) / 60);
    seconds = Math.floor(secondVals % 60);
  }

  let durationVal = [days, hours, minutes, seconds];
  return durationVal;
}

const InputParameter = (props) => {
  const {
    classes,
    deleteInputParam,
    index,
    updateInputParamsValue,
    paramValue,
  } = props;

  const handleChange = (value) => updateInputParamsValue(index, value);

  return (
    <Grid container spacing={2} alignItems="center" justifyContent="center">
      <Grid item xs={11}>
        <Input
          placeholder="e.g.: Cache-Control..."
          fullWidth
          onChange={handleChange}
          value={paramValue}
        />
      </Grid>
      <Grid item xs={1} style={{ alignSelf: "center" }}>
        <div
          className={classes.iconContainer}
          onClick={() => deleteInputParam(index)}
        >
          <Icons.DeleteOutlineOutlined />
        </div>
      </Grid>
    </Grid>
  );
};



const WorkflowDefinationForm = (props) => {
  const {
    values,
    setFieldValue,
    setDataToBeAddedToJson,
    handleBlur,
    workflowDef
  } = props;
  const classes = useStyles();
  const customClasses = useCustomStyles();
  const { data: wfNames, refetch: refetchWfNames, isFetching: isFetchingwfNames } = useWorkflowNames();
  const { taskHeaders, setTaskHeaders, addTaskHeader, updateTaskHeader, deleteTaskHeader, taskHeadersInitialized, setTaskHeadersInitialized } = useHeaderParameterManager()


  useEffect(() => {
    const outputParameters = Object.entries(workflowDef?.outputParameters ?? {});
    if (!isEqual(taskHeaders, outputParameters)) {
      setTaskHeaders(outputParameters)
    }
  }, [workflowDef])

  useEffect(() => {
    if (taskHeaders.length > 0 && !taskHeadersInitialized) {
      setTaskHeadersInitialized(true);
    }
    if (taskHeadersInitialized) {
      setFieldValue("outputParameters", Object.fromEntries(taskHeaders));
    }
  }, [taskHeaders]);
  // useWorkflowNamesAndVersions();
  useEffect(() => {
    refetchWfNames();
  }, []);



  const [workflowDays, setWorkflowDays] = useState(0);
  const [workflowHours, setWorkflowHours] = useState(0);
  const [workflowMins, setWorkflowMins] = useState(0);
  const [workflowSecs, setWorkflowSecs] = useState(0);

  const handleArchiveChange = (e, val) => {

    if (val === true) {
      setWorkflowDays(0);
      setWorkflowHours(0);
      setWorkflowMins(0);
      setWorkflowSecs(0);

    }
    setFieldValue("archive", val);
  };

  const addInputParamsToArr = () =>
    setFieldValue("inputParameters", [...values.inputParameters, ""]);


  const updateInputParamsValue = (index, val) => {
    let temp = [...values.inputParameters];
    temp[index] = val || "";
    setFieldValue("inputParameters", temp);
  };


  const deleteInputParam = (index) => {
    let temp = [...values.inputParameters];
    temp = temp.filter((e, idx) => idx !== index);
    setFieldValue("inputParameters", temp);
  };



  useEffect(() => {
    let time = [];

    if (values.ttlSeconds) {
      time = secondsToDhms(values.ttlSeconds);
      setWorkflowDays(time[0]);
      setWorkflowHours(time[1]);
      setWorkflowMins(time[2]);
      setWorkflowSecs(time[3]);

      props.setWorkflowDays(Math.floor(time[0] * 3600 * 24));
      props.setWorkflowHours(Math.floor(time[1] * 3600));
      props.setWorkflowMinutes(Math.floor(time[2] * 60));
      props.setWorkflowSeconds(Math.floor(time[3]));
      props.setDuration(values.ttlSeconds);
    }
  }, [values.ttlSeconds]);



  useEffect(() => {
    let payload = formDataToPayload(values)

    setDataToBeAddedToJson(payload);
    return () => { };
  }, [setDataToBeAddedToJson, values]);

  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getCategories();
        setCategories(response.data);
      } catch (error) { }
    };

    fetchData();
  }, []);


  const handleDaysChange = (event) => {
    const { value } = event.target;
    // field.onChange(event);
    setWorkflowDays(value);
    props.handleDaysChange(value); // Pass the value to the parent function
  };

  const handleHoursChange = (event) => {
    const { value } = event.target;
    // field.onChange(event);
    setWorkflowHours(value);
    props.handleHoursChange(value); // Pass the value to the parent function
  };

  const handleMinutesChange = (event) => {
    const { value } = event.target;
    // field.onChange(event);
    setWorkflowMins(value);
    props.handleMinutesChange(value); // Pass the value to the parent function
  };

  const handleSecondsChange = (event) => {
    const { value } = event.target;
    // field.onChange(event);
    setWorkflowSecs(value);
    props.handleSecondsChange(value); // Pass the value to the parent function
  };

  const renderCategoryField = () => {
    if (categories.length <= 1) {
      if (categories.length === 1 && props.workflowDef) {
        props.workflowDef.category = categories[0];
      }
      return null; // Don't render the category field
    }

    return (
      <Grid item xs={12}>
        <FormikDropdown
          id="category"
          label="Type"
          name="category"
          variant="outlined"
          fullWidth
          freeSolo
          className={customClasses.dropdownField}
          options={categories.map((obj) => obj)}
          required={true}
          // options={categories.map((obj) => obj.categoryName)}
          taskReferenceName={"category"}
        />
      </Grid>
    );
  };

  return (
    <Form className={classes.main}>
      <div className={classes.fields}>
        <Grid
          container
          spacing={2}
          alignItems="center"
          justifyContent="flex-start">
          <Grid item xs={12}>
            <FormikInput
              id="name"
              label="Workflow Name"
              name="workflowName"
              variant="outlined"
              fullWidth
              required
              taskReferenceName={"workflowName"}
              className={customClasses.inputField}
            />
          </Grid>
          {renderCategoryField()}

          <Grid item xs={12}>
            <FormikInput
              id="description"
              label="Description"
              name="description"
              className={classes.description}
              multiline
              minRows={2}
              maxRows={4}
              variant="outlined"
              fullWidth
              taskReferenceName={"description"}
            />
          </Grid>
        </Grid>

        <div className="">
          <label className={classes.formLabel}>Input Parameters</label>
          {values.inputParameters && values.inputParameters.length
            ? values.inputParameters.map((ele, index) => (
              <InputParameter
                key={index}
                classes={classes}
                index={index}
                deleteInputParam={deleteInputParam}
                updateInputParamsValue={updateInputParamsValue}
                paramValue={ele}
              />
            ))
            : ""}
          <Button className={classes.wolkenBtn} onClick={addInputParamsToArr}>
            Add
          </Button>
        </div>

        <div className="">
          <label className={classes.formLabel}>Output Parameters</label>
          {taskHeaders?.length
            ? taskHeaders.map((keyVal, index) => (
              <KeyValue
                key={index}
                index={index}
                classes={classes}
                inputParameters={values.inputParameters}
                deleteIpParameterVal={deleteTaskHeader}
                updateIpParameterVal={updateTaskHeader}
                keyVal={keyVal}
                inputMode={"KeyValue"}
                uniqueKeys={values.outputParameters}
              />
            ))
            : ""}
        </div>

        <div className={classes.wfFlafDiv}>
          <label className={classes.formLabel}>Workflow Flags</label>
          <FormGroup>
            <FormControlLabel
              control={
                <FormikSwitch
                  color="primary"
                  className={classes.switchRoot}
                  name="restartable"
                  taskReferenceName={"restartable"}
                />
              }
              label="Restartable"
              className={classes.switchContainer}
            />
          </FormGroup>

          <div className={classes.msgTxt}>
            If restarting a completed workflow can have side effects, turn this
            flag off and completed workflows will not be allowed to restart.
          </div>
        </div>

        <Grid
          container
          spacing={2}
          alignItems="center"
          justifyContent="flex-start">
          <Grid item xs={6}>
            <FormikInput
              id="timeout-seconds"
              label="Timeout Seconds"
              name="timeoutSeconds"
              type="number"
              variant="outlined"
              fullWidth
              taskReferenceName={"timeoutSeconds"}
            />
          </Grid>
          <Grid item xs={6}>
            <FormikDropdownAutoComplete
              id="timeout-policy"
              label="Timeout Policy"
              name="timeoutPolicy"
              variant="outlined"
              fullWidth
              className={customClasses.dropdownField}
              options={TIMEOUT_POLICY_OPTIONS}
              taskReferenceName={"timeout-policy"}
            />
          </Grid>
          <Grid item xs={12}>
            <FormikDropdown
              id="faliure-name"
              label="Failure Workflow Name"
              name="failureWorkflow"
              placeholder="e.g.: max-age=..."
              variant="outlined"
              fullWidth
              freeSolo
              className={customClasses.dropdownField}
              options={wfNames ?? []}
              taskReferenceName={"faliure-name"}
              value={values.failureWorkflow}
              loading={isFetchingwfNames || (wfNames !== undefined && wfNames.length === 0)}
              type="string"
            />
            <div className={classes.msgTxt}>
              If present, this workflow will be triggered upon a failure of the
              execution of this workflow.
            </div>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Checkbox
                checked={values.archive}
                color="primary"
                onChange={handleArchiveChange}
              />
            }
            label="Archive"
          />
        </Grid>

        {!values.archive && <>
          <div className="">
            <label className={classes.formLabel}>Time To Live</label>
          </div>
          <Grid
            container
            spacing={2}
            alignItems="center"
            marginTop={10}
            justifyContent="flex-start">
            <Grid item xs={3}>
              <FormikInput
                id="workflowDays"
                label="Days"
                name="workflowDays"
                type="number"
                variant="outlined"
                fullWidth
                value={workflowDays}
                onChange={handleDaysChange}

                error={workflowDays < 0}
              />
              <div style={{ minHeight: "24px" }}>
                {workflowDays < 0 && (
                  <FormControl error={workflowDays < 0}>
                    <FormHelperText>Days must be 0 or more</FormHelperText>
                  </FormControl>
                )}
              </div>
            </Grid>

            <Grid item xs={3}>
              <FormikInput
                id="workflowHours"
                label="Hours"
                name="workflowHours"
                type="number"
                variant="outlined"
                fullWidth
                value={workflowHours}
                onChange={handleHoursChange}

                error={(workflowHours < 0 || workflowHours > 23)}
              />
              <div style={{ minHeight: "24px" }}>
                {workflowHours < 0 ? (
                  <FormControl error={workflowHours < 0}>
                    <FormHelperText>Hours must be 0 or more</FormHelperText>
                  </FormControl>
                ) : (

                  workflowHours > 23 && (
                    <FormControl error={workflowHours > 23}>
                      <FormHelperText>Hours must be less than 24</FormHelperText>
                    </FormControl>
                  )
                )}
              </div>
            </Grid>

            <Grid item xs={3}>
              <FormikInput
                id="workflowMins"
                label="Minutes"
                name="workflowMins"
                type="number"
                variant="outlined"
                fullWidth
                value={workflowMins}
                onChange={handleMinutesChange}

                error={(workflowMins < 0 || workflowMins > 59)}
              />
              <div style={{ minHeight: "24px" }}>
                {workflowMins < 0 ? (
                  <FormControl error={workflowMins < 0}>
                    <FormHelperText>Mins must be 0 or more</FormHelperText>
                  </FormControl>
                ) : (

                  workflowMins > 59 && (
                    <FormControl error={workflowMins > 59}>
                      <FormHelperText>Mins must be less than 60</FormHelperText>
                    </FormControl>
                  )
                )}
              </div>
            </Grid>

            <Grid item xs={3}>
              <FormikInput
                id="workflowSecs"
                label="Seconds"
                name="workflowSecs"
                type="number"
                variant="outlined"
                fullWidth
                value={workflowSecs}
                onChange={handleSecondsChange}
                handleBlur={handleBlur}

                error={(workflowSecs < 0 || workflowSecs > 59)}
              />
              <div style={{ minHeight: "24px" }}>
                {workflowSecs < 0 ? (
                  <FormControl error={workflowSecs < 0}>
                    <FormHelperText>Secs must be 0 or more</FormHelperText>
                  </FormControl>
                ) : (

                  workflowSecs > 59 && (
                    <FormControl error={workflowSecs > 59}>
                      <FormHelperText>Secs must be less than 60</FormHelperText>
                    </FormControl>
                  )
                )}
              </div>
            </Grid>
          </Grid>
        </>
        }
      </div>
      {/* </div> */}
    </Form>
  );
};

function formDataToPayload(values) {
  let timeoutPolicy = values?.timeoutPolicy;
  if (timeoutPolicy && typeof timeoutPolicy === 'object') {
    timeoutPolicy = timeoutPolicy.value;
  }
  return { ...values, timeoutPolicy };
}

function workflowDefPayloadToFormData(workflowDefPayload, workflowDef) {
  let opParam = workflowDef?.outputParameters ?? {}
  return {
    name:
      _.get(workflowDefPayload, "name", "") ||
      _.get(workflowDef, "name", "") ||
      null,
    workflowName:
      _.get(workflowDefPayload, "workflowName", "") ||
      _.get(workflowDef, "workflowName", ""),
    description:
      _.get(workflowDefPayload, "description", "") ||
      _.get(workflowDef, "description", ""),
    category:
      _.get(workflowDefPayload, "category", "") ||
      _.get(workflowDef, "category", ""),
    version:
      _.get(workflowDefPayload, "version", 1) ||
      _.get(workflowDef, "version", 1),
    inputParameters:
      _.get(workflowDefPayload, "inputParameters") ||
      _.get(workflowDef, "inputParameters"),
    outputParameters: _.get(workflowDefPayload, "outputParameters") || opParam,
    restartable:
      _.get(workflowDefPayload, "restartable", false) ||
      _.get(workflowDef, "restartable", false),
    timeoutSeconds:
      _.get(workflowDefPayload, "timeoutSeconds", "") ||
      _.get(workflowDef, "timeoutSeconds", ""),
    timeoutPolicy:
      TIMEOUT_POLICY_OPTIONS.find(
        (option) => option.value === _.get(workflowDef, "timeoutPolicy", "")
      ) || null,
    failureWorkflow: _.get(workflowDefPayload, "failureWorkflow", "") || _.get(workflowDef, "failureWorkflow", ""),
    ttlSeconds:
      _.get(workflowDefPayload, "ttlSeconds", "") ||
      _.get(workflowDef, "ttlSeconds", ""),
    archive:
      _.get(workflowDefPayload, "archive", false) ||
      _.get(workflowDef, "archive", false),
  };
}

export default withFormik({
  enableReinitialize: true,
  mapPropsToValues: (props) =>
    workflowDefPayloadToFormData(
      _.get(props, "workflowDefPayload"),
      _.get(props, "workflowDef")
    ),
  validationSchema: Yup.object().shape({
    workflowName: Yup.string()
      .max(50, "Name must be at most 50 characters")
      .matches(/^[a-zA-Z0-9._ ]+$/, "Name cannot contain special characters")
      // .matches(/^[a-zA-Z\s]+$/, "Name cannot contain special characters")
      .required("Name is required")
      .nullable(),
    category: Yup.string().required("Category is required").nullable(),
    workflowDays: Yup.number().min(0, "Days must be 0 or more"),
    workflowHours: Yup.number()
      .min(0, "Hours must be 0 or more")
      .max(23, "Hours must be less than 24"),
    workflowMins: Yup.number()
      .min(0, "Minutes must be 0 or more")
      .max(59, "Minutes must be less than 60"),
    workflowSecs: Yup.number()
      .min(0, "Seconds must be 0 or more")
      .max(59, "Seconds must be less than 60"),

    // Add other validation rules for other fields if needed
  }),
})(WorkflowDefinationForm);
